import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { Form } from "react-final-form";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import TileFooter from "components/TileFooter";
import * as fu from "./_utils";
import * as utils from "common/utils";
import Alert from "components/Alert";
import createDecorator from "final-form-calculate";
import * as validations from "common/validations";
import { Link } from "react-router-dom";
import { validateNutrients, nutrientDecorators } from "components/Nutrients";
import ActivitySummaryCrops from "./ActivitySummaryCrops";
import ActivitySummaryOther from "./ActivitySummaryOther";
import Activity from "./Activity";
import { v4 as uuidv4 } from "uuid";
import { showDmContent, showPerOrganicN, showDairyEffluent, showEffluentForm } from "./ProductType/Organic";
import { Field } from "react-final-form";
import SavePrompt from "components/SavePrompt";
import Fertiliser from "./ProductType/Fertiliser";
import Lime from "./ProductType/Lime";
import Organic from "./ProductType/Organic";
import Soluble from "./ProductType/Soluble";
import Nutrients from "components/Nutrients";
import ActionLink from "components/ActionLink";
import { modal } from "containers/App/_actions";

const mapFertiliser = (source, destination) => {
    if (!source || !destination) return;
    destination.nutrients = source.nutrients;
    destination.productName = source.productName || source.name;
    destination.effluentForm = source.effluentForm;
    destination.dairyFactoryEffluent = source.dairyFactoryEffluent;
    destination.percentageOrganicN = source.percentageOrganicN;
    destination.dmContent = source.dmContent;
    destination.organicType = source.organicType;
    destination.nType = source.nType;
    destination.pType = source.pType;
    destination.percentElementalS = source.percentElementalS;
    destination.mgType = source.mgType;
    destination.nutrientUnit = source.nutrientUnit || source.effluentUnit;
};

const materialToType = (material) => {
    switch (material) {
        case "Product":
            return "Fertiliser";
        case "Organic":
            return "Effluent";
        default:
            return material;
    }
};

const hideNutrientsOnFertiliser = (fertiliser) => {
    return fu.nutrientsOnApplication(fertiliser) || (fertiliser.organicType === "Dairyfactory" && ["Lacticacidwhey", "Sulphuricacidwhey", "Cheesewhey", "None"].includes(fertiliser.dairyFactoryEffluent)) || (fertiliser.material === "Organic" && !fertiliser.organicType) || (fertiliser.organicType === "Dairyfactory" && !fertiliser.dairyFactoryEffluent);
};

class Details extends React.Component {
    constructor(props) {
        super(props);
        this.refData = props.refData;
        this.budget = props.budget;
        this.cropBlockIds = this.props.budget.blocks.filter((b) => ["FodderCrop", "ProductiveCrop"].includes(b.type)).map((c) => c.id);
        this.otherBlockIds = this.props.budget.blocks.filter((b) => !["FodderCrop", "ProductiveCrop"].includes(b.type) && b.isProductive).map((c) => c.id);
        this.newFertiliserId = uuidv4();

        this.allowAddCropApplication = this.cropBlockIds.length > 0;
        this.allowAddPastureApplication = props.budget.blocks.some((b) => ["ProductiveFruit", "ProductivePasture"].includes(b.type));
        const params = new URLSearchParams(this.props.location.search);
        const material = params.get("type");
        let productSource = this.props.isNew ? (["Organic", "Soluble"].includes(material) ? "CUSTOM" : "MANUFACTURER") : props.fertiliser.productId === 0 ? "CUSTOM" : "MANUFACTURER";

        this.state = {};
        this.state.viewModel = {
            fertiliser: utils.clone(props.fertiliser),
            productSource,
            isNew: props.isNew,
            origId: props.fertiliser.id,
            origProdId: props.fertiliser.productId,
            budget: props.budget,
        };
        if (props.isNew) {
            this.state.viewModel.fertiliser.material = material;
            this.state.viewModel.fertiliser.isLastPreviousLime = params.get("ispl") === "1";
        } else {
            const manufacturerId = isNaN(props.fertiliser.manufacturerId) ? undefined : parseInt(props.fertiliser.manufacturerId, 10);
            const manufacturer = props.refData.fertiliser.find((p) => p.id === manufacturerId) || { products: [] };
            if (manufacturer.products.length > 0 && props.fertiliser.productName && !isNaN(props.fertiliser.productId) && !manufacturer.products.find((p) => String(p.id) === String(props.fertiliser.productId))) {
                this.state.viewModel.retired = {
                    value: props.fertiliser.productId,
                    text: props.fertiliser.productName,
                    manufacturerId: props.fertiliser.manufacturerId,
                    nutrients: props.fertiliser.nutrients,
                    nType: props.fertiliser.nType,
                    pType: props.fertiliser.pType,
                    percentElementalS: props.fertiliser.percentElementalS,
                    mgType: props.fertiliser.mgType,
                };
            }
        }
        this.state.viewModel.productSource_prev = this.state.viewModel.productSource;
        this.state.viewModel.manufacturerId_prev = this.state.viewModel.fertiliser.manufacturerId;
        this.state.viewModel.productId_prev = this.state.viewModel.fertiliser.productId;
        this.state.viewModel.id_prev = this.state.viewModel.fertiliser.id;

        this.customFertiliser = utils.clone(props.budget.fertiliser.filter((f) => f.manufacturerId === fu.CustomManufacturerId && f.material === this.state.viewModel.fertiliser.material && f.isLastPreviousLime === this.state.viewModel.fertiliser.isLastPreviousLime));

        switch (this.state.viewModel.fertiliser.material) {
            case fu.ProductType.Lime:
                this.productHeading = this.state.viewModel.fertiliser.isLastPreviousLime ? "previous lime" : "lime";
                break;
            case fu.ProductType.Organic:
                this.productHeading = "organic fertiliser";
                break;
            case fu.ProductType.Soluble:
                this.productHeading = "soluble fertiliser";
                break;
            default:
                this.productHeading = "fertiliser product";
                break;
        }

        this.decorators = [
            nutrientDecorators(),
            createDecorator(
                {
                    field: "productSource",
                    updates: (fieldValue, fieldName, allValues) => {
                        const vm = Object.assign({}, allValues);
                        if (fieldValue === vm.productSource_prev) return {};
                        vm.productSource_prev = fieldValue;
                        const { fertiliser = {} } = vm;
                        const existing = fieldValue === "EXISTING" && this.props.budget.fertiliser.find((f) => String(f.id) === String(fertiliser.id));
                        vm.id_prev = undefined;
                        if (existing) {
                            mapFertiliser(existing, fertiliser);
                        } else {
                            fertiliser.manufacturerId = undefined;
                            fertiliser.productId = undefined;
                            fertiliser.nutrients = undefined;
                            fertiliser.nType = undefined;
                            fertiliser.pType = undefined;
                            fertiliser.percentElementalS = undefined;
                            fertiliser.mgType = undefined;
                            fertiliser.productName = undefined;
                            vm.existing = undefined;
                            vm.productId_prev = undefined;
                        }
                        return vm;
                    },
                },
                {
                    field: "fertiliser.dairyFactoryEffluent",
                    updates: (fieldValue, fieldName, allValues) => {
                        const vm = Object.assign({}, allValues);
                        if (vm.fertiliser.material !== fu.ProductType.Organic && vm.fertiliser.organicType === "Dairyfactory") return {};
                        const customComposition = this.customCompositions().find((c) => c.id === vm.fertiliser.dairyFactoryEffluent);
                        vm.fertiliser.nutrients = customComposition ? customComposition.nutrients : vm.fertiliser.nutrients;
                        vm.fertiliser.nutrientUnit = customComposition ? customComposition.effluentUnit : vm.fertiliser.nutrientUnit;
                        vm.globalSelect = customComposition ? "source.fertiliser.dairyFactoryEffluent" : undefined;
                        if (vm.fertiliser.dairyFactoryEffluent === "Userdefined") {
                            const { applications = [] } = vm.fertiliser;
                            applications.forEach((app) => {
                                app.unit = "kgha";
                            });
                        }
                        return vm;
                    },
                },
                {
                    field: "fertiliser.organicType",
                    updates: (fieldValue, fieldName, allValues) => {
                        const vm = Object.assign({}, allValues);
                        vm.globalSelect = false;
                        const { applications = [] } = vm.fertiliser;
                        vm.fertiliser.nutrientUnit = "Percent";
                        if (!["Dairyfactory"].includes(fieldValue)) {
                            delete vm.fertiliser.dairyFactoryEffluent;
                        }
                        if (["Otherorganicmaterial", "CompostMulches"].includes(fieldValue)) {
                            const { nutrients = {} } = vm.fertiliser;
                            const keys = Object.keys(nutrients) || [];
                            keys.forEach((k) => (nutrients[k] = utils.round(nutrients[k], 1)));
                        }
                        if (fieldValue === "CompostMulches") {
                            applications.forEach((app) => {
                                app.unit = "tonnes";
                            });
                        }
                        if (fu.nutrientsOnApplication(vm.fertiliser)) {
                            applications.forEach((app) => {
                                delete app.amount;
                            });
                        } else {
                            applications.forEach((app) => {
                                app.nutrients = {};
                            });
                        }
                        return vm;
                    },
                },
                {
                    field: "fertiliser.manufacturerId",
                    updates: (fieldValue, fieldName, allValues) => {
                        const vm = Object.assign({}, allValues);
                        if (fieldValue === vm.manufacturerId_prev) return {};
                        const manufacturer = this.props.refData.fertiliser.find((f) => String(f.id) === fieldValue);
                        vm.manufacturerId_prev = fieldValue;
                        const { fertiliser = {} } = vm;
                        fertiliser.productId = undefined;
                        fertiliser.nutrients = undefined;
                        fertiliser.nType = undefined;
                        fertiliser.pType = undefined;
                        fertiliser.percentElementalS = undefined;
                        fertiliser.mgType = undefined;
                        fertiliser.productName = undefined;
                        vm.existing = undefined;
                        if (manufacturer) {
                            fertiliser.manufacturer = manufacturer.name;
                        }
                        return vm;
                    },
                },
                {
                    field: "fertiliser.id",
                    updates: (fieldValue, fieldName, allValues) => {
                        const vm = Object.assign({}, allValues);
                        if (fieldValue === vm.id_prev) return {};
                        vm.id_prev = fieldValue;
                        vm.existing = fieldValue && this.props.budget.fertiliser.find((f) => String(f.id) === String(fieldValue) && String(fieldValue) !== String(vm.origId));
                        const existingFert = this.customFertiliser.find((f) => f.id === fieldValue) || this.customCompositions().find((c) => String(c.id) === String(fieldValue));
                        vm.globalSelect = undefined;
                        if (existingFert) {
                            mapFertiliser(existingFert, vm.fertiliser);
                            if (!vm.existing && existingFert.id !== vm.origId) {
                                vm.resetIdOnSave = true;
                                vm.globalSelect = "source.fertiliser.id";
                            }
                        } else {
                            const { fertiliser = {} } = vm;
                            fertiliser.productId = undefined;
                            fertiliser.nutrients = undefined;
                            fertiliser.nType = undefined;
                            fertiliser.pType = undefined;
                            fertiliser.percentElementalS = undefined;
                            fertiliser.mgType = undefined;
                            fertiliser.productName = undefined;
                            vm.existing = undefined;
                        }
                        return vm;
                    },
                },
                {
                    field: "fertiliser.productId",
                    updates: (fieldValue, fieldName, allValues) => {
                        const vm = Object.assign({}, allValues);
                        if (fieldValue === vm.productId_prev || !fieldValue) return {};
                        vm.productId_prev = fieldValue;
                        const { fertiliser = {} } = vm;
                        const copyNutrients = (p) => ({ N: p.n, P: p.p, K: p.k, S: p.s, Ca: p.ca, Mg: p.mg, Na: p.na });
                        vm.existing = fieldValue && this.props.budget.fertiliser.find((f) => String(f.productId) === String(fieldValue) && String(fieldValue) !== String(vm.origProdId) && f.material === fertiliser.material && f.isLastPreviousLime === fertiliser.isLastPreviousLime);
                        switch (fertiliser.material) {
                            case fu.ProductType.Lime: {
                                const lime = this.props.refData.lime.find((l) => String(l.id) === String(fieldValue));
                                if (lime) {
                                    fertiliser.manufacturer = "Lime";
                                    fertiliser.productName = lime.name;
                                    fertiliser.nutrients = copyNutrients(lime);
                                    fertiliser.nType = "None";
                                    fertiliser.pType = "None";
                                    fertiliser.percentElementalS = 0;
                                    fertiliser.mgType = "None";
                                    fertiliser.nutrientUnit = "Percent";
                                }
                                break;
                            }
                            default: {
                                const manufacturer = this.refData.fertiliser.find((f) => String(f.id) === String(fertiliser.manufacturerId), 10);
                                if (manufacturer) {
                                    const product = manufacturer.products.find((f) => String(f.id) === String(fieldValue));
                                    if (product) {
                                        fertiliser.productName = product.name;
                                        fertiliser.nutrients = copyNutrients(product);
                                        const { nutrientNType = [], nutrientPType = [], nutrientMgType = [] } = this.props.refData;
                                        fertiliser.nType = nutrientNType.length > product.nType ? nutrientNType[product.nType].value : "None";
                                        fertiliser.pType = nutrientPType.length > product.pType ? nutrientPType[product.pType].value : "None";
                                        fertiliser.mgType = nutrientMgType.length > product.mgType ? nutrientMgType[product.mgType].value : "None";
                                        fertiliser.percentElementalS = product.elementalS;
                                        fertiliser.nutrientUnit = "Percent";
                                    } else if (allValues.retired) {
                                        const { retired } = allValues;
                                        fertiliser.productName = retired.text;
                                        fertiliser.nutrients = retired.nutrients;
                                        fertiliser.nType = retired.nType;
                                        fertiliser.pType = retired.pType;
                                        fertiliser.mgType = retired.mgType;
                                        fertiliser.percentElementalS = retired.percentElementalS;
                                        fertiliser.nutrientUnit = "Percent";
                                    }
                                }
                                break;
                            }
                        }
                        return vm;
                    },
                }
            ),
        ];
    }

    customCompositions() {
        return utils.clone(this.props.customCompositions.filter((c) => c.type === materialToType(this.state.viewModel.fertiliser.material)));
    }

    onSubmit(values) {
        const { fertiliser, existing } = values;
        utils.delYear1FromNonCropBlocks(fertiliser.applications, this.props.budget);
        this.setDataTypes(values);
        if (existing && existing.id !== fertiliser.id) {
            this.props.deleteFertiliser(this.props.farm.id, this.props.budget.id, { id: existing.id });
        } else if (values.origId !== fertiliser.id) {
            this.props.deleteFertiliser(this.props.farm.id, this.props.budget.id, { id: values.origId });
        }
        this.props.submit(this.props.farm.id, this.props.budget.id, fertiliser);
    }

    setDataTypes(viewModel) {
        const { fertiliser, productSource } = viewModel;
        if (viewModel.resetIdOnSave) {
            fertiliser.id = this.newFertiliserId;
        }
        if (productSource !== "MANUFACTURER") {
            fertiliser.manufacturerId = 1;
            fertiliser.productId = 0;
            fertiliser.manufacturer = fertiliser.customCompositionId ? `Global ${this.productHeading}` : `Custom ${this.productHeading}`;
        }
        if (!["CompostMulches", "Otherorganicmaterial"].includes(fertiliser.organicType)) {
            fertiliser.dmContent = 0;
        }
        if (!["Otherorganicmaterial"].includes(fertiliser.organicType)) {
            fertiliser.percentageOrganicN = 0;
        }
        if (!["Dairyfactory"].includes(fertiliser.organicType)) {
            delete fertiliser.dairyFactoryEffluent;
        }
        if (!["Piggeryeffluent", "Importeddairyeffluent"].includes(fertiliser.organicType)) {
            delete fertiliser.effluentForm;
        }
        if (fertiliser.id === "NEW") fertiliser.id = this.newFertiliserId;
        fertiliser.dmContent = parseFloat(fertiliser.dmContent) || 0;
        fertiliser.percentageOrganicN = parseFloat(fertiliser.percentageOrganicN) || 0;
        if (fertiliser.material === fu.ProductType.Organic && fertiliser.organicType === "Dairyfactory" && this.customCompositions().find((c) => c.id === fertiliser.dairyFactoryEffluent)) {
            fertiliser.dairyFactoryEffluent = "Userdefined";
        }
        /* eslint-disable no-unused-vars */
        for (const application of fertiliser.applications) {
            application.amount = parseFloat(application.amount) || 0;
            if (fu.kghaOnly(viewModel)) {
                application.unit = "kgha";
            }
            if (viewModel.fertiliser.organicType === fu.CompostMulches) {
                application.unit = "tonnes";
            }
        }
        if (fertiliser.material !== fu.ProductType.Organic) {
            delete fertiliser.organicType;
        }

        if (fertiliser.material === fu.ProductType.Product) {
            const noNitrogen = !fertiliser.nutrients.N > 0;
            if (noNitrogen) {
                fertiliser.nType = "None";
            }
            /* eslint-disable no-unused-vars */
            for (const application of fertiliser.applications) {
                const selectedBlocks = application.blockIds.map((id) => this.props.budget.blocks.find((b) => b.id === id));
                const hasCrops = selectedBlocks.some((b) => ["FodderCrop", "ProductiveCrop"].includes(b.type));
                if (!hasCrops || noNitrogen) {
                    application.nFertAppMethod = "None";
                }
            }
            if (!fertiliser.nutrients.N > 0) fertiliser.nType = "None";
            if (!fertiliser.nutrients.P > 0) fertiliser.pType = "None";
            if (!fertiliser.nutrients.S > 0) fertiliser.percentElementalS = 0;
            if (!fertiliser.nutrients.Mg > 0) fertiliser.mgType = "None";
        }

        if (fu.nutrientsOnApplication(fertiliser)) {
            delete fertiliser.nutrients;
            delete fertiliser.nutrientUnit;
            /* eslint-disable no-unused-vars */
            for (const application of fertiliser.applications) {
                application.amount = 0;
            }
        } else {
            /* eslint-disable no-unused-vars */
            for (const application of fertiliser.applications) {
                delete application.nutrients;
            }
        }
    }

    deleteApplication(id, values) {
        values.fertiliser.applications = values.fertiliser.applications.filter((a) => a.id !== id);
        this.setState({ viewModel: values });
    }

    applicationMonth(source, e) {
        const { viewModel } = this.state;
        const application = viewModel.fertiliser.applications.find((a) => a.id === source.applicationId);
        if (!fu.removeMonth(application, source.value, source.reportingYear)) {
            application.months.push({ month: source.value, reportingYear: source.reportingYear || false });
        }
        this.setState({ viewModel });
    }

    saveApplication(application) {
        const { viewModel } = this.state;
        const { applications = [] } = viewModel.fertiliser;
        viewModel.fertiliser.applications = applications;
        utils.merge(application, applications);
        this.setState(viewModel);
    }

    editApplication(id, isCrop, viewModel) {
        const application = utils.clone(viewModel.fertiliser.applications.find((a) => a.id === id));
        if (!fu.nutrientsOnApplication(this.state.viewModel.fertiliser)) application.nutrients = {};
        if (viewModel.fertiliser.organicType === fu.CompostMulches) {
            application.unit = "tonnes";
        }
        this.setState({ selectedApplication: application, isCrop, viewModel, correlationId: uuidv4() }, () => this.props.modalInlineOpen());
    }

    addApplication(isCrop, viewModel) {
        const application = {
            id: uuidv4(),
            months: [],
            unit: "kgha",
            blockIds: [],
            reportingYear: true,
        };
        if (fu.nutrientsOnApplication(this.state.viewModel.fertiliser)) application.nutrients = {};
        if (viewModel.fertiliser.organicType === fu.CompostMulches) {
            application.unit = "tonnes";
        }
        this.setState({ selectedApplication: application, isCrop, viewModel, correlationId: uuidv4() }, () => this.props.modalInlineOpen());
    }

    render() {
        const _referrer = `/app/farm/${this.props.farm.id}/analysis/${this.props.budget.id}/fertiliser`;

        return (
            <React.Fragment>
                {this.props.isModalOpen && this.state.selectedApplication && <Activity refData={this.props.refData} budget={this.props.budget} isCrop={this.state.isCrop} viewModel={this.state.viewModel} fertiliser={this.state.viewModel.fertiliser} saveApplication={(a) => this.saveApplication(a)} heading={this.productHeading} application={this.state.selectedApplication} correlationId={this.state.correlationId} fertiliserName={this.state.viewModel.fertiliser.productName} />}
                <Form
                    onSubmit={(values) => this.onSubmit(values)}
                    initialValues={this.state.viewModel}
                    decorators={this.decorators}
                    validate={(values) => {
                        const errors = { fertiliser: {} };
                        const nutrientsOnApplication = fu.nutrientsOnApplication(values.fertiliser);
                        const nutrientsOnFertiliser = !hideNutrientsOnFertiliser(values.fertiliser);
                        errors.fertiliser.productName = validations.required(values.fertiliser.productName);
                        errors.fertiliser.productName = errors.fertiliser.productName || validations.maxLength(200)(values.fertiliser.productName);
                        errors.fertiliser.productName = errors.fertiliser.productName || (this.budget.fertiliser.find((f) => (String(values.fertiliser.productId) === "0" || !values.fertiliser.productId) && values.fertiliser.productName && f.productName && f.isLastPreviousLime === values.fertiliser.isLastPreviousLime && f.id !== values.fertiliser.id && values.fertiliser.productName.trim().toUpperCase() === f.productName.trim().toUpperCase()) ? "Name already in use" : undefined);
                        errors.applications = !values.fertiliser.applications || values.fertiliser.applications.length === 0 ? "Please add at least one activity in crops or pasture" : undefined;

                        if (values.submit) {
                            values.fertiliser.applications.forEach((app) => {
                                errors[fu.amountId(app.id)] = nutrientsOnApplication ? undefined : validations.required(app.amount);
                                errors[fu.monthGroupId(app.id)] = (!app.months || app.months.length === 0) && !values.fertiliser.isLastPreviousLime ? "Please select at least one month" : undefined;
                                if (nutrientsOnApplication && !errors[fu.monthGroupId(app.id)]) {
                                    const nutrientErrors = validateNutrients(app, "Soluble");
                                    errors[fu.monthGroupId(app.id)] = nutrientErrors.nutrientSum;
                                }
                                if (!errors[fu.monthGroupId(app.id)]) {
                                    const selectedBlocks = app.blockIds.map((id) => this.props.budget.blocks.find((b) => b.id === id));
                                    const hasCrops = selectedBlocks.some((b) => ["FodderCrop", "ProductiveCrop"].includes(b.type));
                                    const { nutrients = {} } = values.fertiliser;
                                    if (!fu.hideNFertAppMethod(nutrients, hasCrops, values.fertiliser)) {
                                        errors[fu.monthGroupId(app.id)] = validations.required(app.nFertAppMethod) || app.nFertAppMethod === "None" ? "Application method required" : undefined;
                                    }
                                }
                            });
                        }
                        switch (values.productSource) {
                            case "MANUFACTURER": {
                                const productId = values.fertiliser.productId === "0" ? undefined : values.fertiliser.productId;
                                errors.fertiliser.productId = validations.required(productId);
                                switch (values.fertiliser.material) {
                                    case fu.ProductType.Product:
                                        errors.fertiliser.manufacturerId = validations.required(values.fertiliser.manufacturerId);
                                        errors.fertiliser.manufacturerId = errors.fertiliser.manufacturerId || (values.fertiliser.manufacturerId === "0" ? "Required" : undefined);
                                        break;
                                    default:
                                        break;
                                }
                                break;
                            }
                            case "GLOBAL":
                                errors.fertiliser.customCompositionId = validations.required(values.fertiliser.customCompositionId);
                                break;
                            case "CUSTOM":
                                switch (values.fertiliser.material) {
                                    case fu.ProductType.Organic:
                                        errors.fertiliser.organicType = validations.required(values.fertiliser.organicType);
                                        if (showDmContent(values.fertiliser)) {
                                            errors.fertiliser.dmContent = validations.required(values.fertiliser.dmContent);
                                            errors.fertiliser.dmContent = errors.fertiliser.dmContent || validations.range(1, 100)(values.fertiliser.dmContent);
                                        }
                                        if (showPerOrganicN(values.fertiliser)) {
                                            errors.fertiliser.percentageOrganicN = errors.fertiliser.percentageOrganicN || validations.range(0, 100)(values.fertiliser.percentageOrganicN);
                                        }
                                        if (showDairyEffluent(values.fertiliser)) {
                                            errors.fertiliser.dairyFactoryEffluent = validations.required(values.fertiliser.dairyFactoryEffluent);
                                        }
                                        if (showEffluentForm(values.fertiliser)) {
                                            errors.fertiliser.effluentForm = validations.required(values.fertiliser.effluentForm);
                                        }
                                        break;
                                    default:
                                        break;
                                }
                                if (nutrientsOnFertiliser) {
                                    const nutrientErrors = validateNutrients(values.fertiliser, values.fertiliser.material);
                                    errors.fertiliser = { ...errors.fertiliser, ...nutrientErrors };
                                }
                                break;
                            default:
                                break;
                        }
                        return errors;
                    }}
                    render={({ handleSubmit, dirty, submitSucceeded, values, errors, form }) => {
                        const { fertiliser } = values;
                        const { nutrients = {} } = fertiliser;
                        const { fertiliser: fertErrors = {} } = errors;
                        const productSelected = !fertErrors.productId && !fertErrors.manufacturerId && !fertErrors.customCompositionId;
                        const messageWithApps = fertiliser.isLastPreviousLime ? "Edit or delete previous lime applications for the blocks listed below" : "Select the months on which the fertiliser was supplied. Create new applications for applications of different amounts or rates.";
                        const hasCrops = fertiliser.applications.some((a) => a.blockIds.some((i) => this.cropBlockIds.includes(i)));
                        const hasOther = fertiliser.applications.some((a) => a.blockIds.some((i) => this.otherBlockIds.includes(i)));
                        const icon = utils.getFertiliserIcon(fertiliser.material);
                        const preSubmit = () => {
                            const { existing } = values;
                            const { submit: mergeDone } = values;
                            form.change("submit", true);
                            if (!existing || mergeDone) return;
                            form.change("fertiliser.applications", [...existing.applications, ...fertiliser.applications]);
                        };
                        const hideNutrients = hideNutrientsOnFertiliser(fertiliser);
                        const readonly = (["Product", "Lime"].includes(fertiliser.material) && values.productSource === "MANUFACTURER") || values.existing;
                        const nutType = fertiliser.material === "Organic" && hideNutrients ? "OrganicApplication" : fertiliser.material;

                        return (
                            <form onSubmit={handleSubmit}>
                                <SavePrompt blockIf={dirty && !submitSucceeded && !values.submit} redirectIf={submitSucceeded} redirectTo={_referrer} />
                                <input type="hidden" id="fertiliser.newid" value={fertiliser.id} />
                                <input type="hidden" id="new.id" value={this.newFertiliserId} />
                                <Tile title={`${this.props.isNew ? "Add" : "Edit"} ${this.productHeading}`} referrer={_referrer} img={icon}>
                                    <Alert type="info" text="Create a new or select an existing fertiliser and add applications to blocks. Each application may be defined for multiple blocks and months of the year." />
                                    <TileBody>
                                        <div className="Grid">
                                            {fertiliser.material === "Lime" && <Lime customCompositions={this.customCompositions()} customFertiliser={this.customFertiliser} viewModel={values} refData={this.refData} />}
                                            {fertiliser.material === "Organic" && <Organic customCompositions={this.customCompositions()} customFertiliser={this.customFertiliser} viewModel={values} refData={this.refData} />}
                                            {fertiliser.material === "Soluble" && <Soluble customCompositions={this.customCompositions()} customFertiliser={this.customFertiliser} viewModel={values} refData={this.refData} />}
                                            {fertiliser.material === "Product" && <Fertiliser customCompositions={this.customCompositions()} customFertiliser={this.customFertiliser} viewModel={values} refData={this.refData} />}
                                            <div className="Grid-cell u-md-width1of1 u-lg-width2of3">{!hideNutrients && <Nutrients type={nutType} unitReadOnly={true} errors={errors} refData={this.refData} nutrients={nutrients} readonly={readonly} organicType={values.fertiliser.organicType} />}</div>
                                        </div>
                                        {productSelected && this.otherBlockIds.length > 0 && (
                                            <div className="Grid-cell u-mt-lg">
                                                <Tile
                                                    title="Pasture and fruit applications"
                                                    actions={
                                                        <span className="IconLink--arrow-plus u-link" onClick={() => this.addApplication(false, values)} id="fertiliser_add_application_other">
                                                            Add pasture or fruit application
                                                        </span>
                                                    }
                                                    tertiary
                                                >
                                                    <Alert type="info" text={values.fertiliser.applications.length > 0 ? messageWithApps : "Select add application (on the right side of the blue heading) to add applications of this fertiliser."} />
                                                    <TileBody>
                                                        {hasOther ? (
                                                            <ActivitySummaryOther blocks={this.props.budget.blocks.filter((b) => b.isProductive === true)} fertiliser={values.fertiliser} deleteApplication={(id) => this.deleteApplication(id, values)} onChange={(a, b) => this.applicationMonth(a, b)} editApplication={(id) => this.editApplication(id, false, values)} validation={errors} budget={this.props.budget} refData={this.props.refData} heading={this.productHeading} fertiliserName={values.fertiliser.productName} />
                                                        ) : (
                                                            <div className="Table u-mt-md">
                                                                <div className="Tile-body">
                                                                    <div className="Tile-body-message">
                                                                        <Field name="applications">
                                                                            {({ meta }) => (
                                                                                <React.Fragment>
                                                                                    <ActionLink className="IconLink--arrow-plus Button Button--sm u-mt-md" onClick={() => this.addApplication(false, values)} id="fertiliser_summary_add_pasture">
                                                                                        <span>Add pasture or fruit application</span>
                                                                                    </ActionLink>
                                                                                    {meta.touched && meta.error && (
                                                                                        <div className="u-mt-lg Field has-error">
                                                                                            <div>
                                                                                                <small className="Field-error">{meta.error}</small>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </React.Fragment>
                                                                            )}
                                                                        </Field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </TileBody>
                                                </Tile>
                                            </div>
                                        )}
                                        {productSelected && this.allowAddCropApplication && (
                                            <div className="Grid-cell u-mt-lg">
                                                <Tile
                                                    title="Crop applications"
                                                    actions={
                                                        <span className="IconLink--arrow-plus u-link" onClick={() => this.addApplication(true, values)} id="fertiliser_add_application_crop">
                                                            Add crop application
                                                        </span>
                                                    }
                                                    tertiary
                                                >
                                                    <Alert type="info" text={values.fertiliser.applications.length > 0 ? messageWithApps : "Select add application (on the right side of the blue heading) to add applications of this fertiliser."} />
                                                    <TileBody>
                                                        {hasCrops ? (
                                                            <ActivitySummaryCrops blocks={this.props.budget.blocks.filter((b) => b.isProductive === true)} fertiliser={values.fertiliser} deleteApplication={(id) => this.deleteApplication(id, values)} onChange={(a, b) => this.applicationMonth(a, b)} editApplication={(id) => this.editApplication(id, true, values)} budget={this.props.budget} refData={this.props.refData} heading={this.productHeading} validation={errors} fertiliserName={values.fertiliser.productName} />
                                                        ) : (
                                                            <div className="Table u-mt-md">
                                                                <div className="Tile-body">
                                                                    <div className="Tile-body-message">
                                                                        <ActionLink className="IconLink--arrow-plus Button Button--sm u-mt-md" onClick={() => this.addApplication(true, values)} id="fertiliser_summary_add_crop">
                                                                            <span>Add crop application</span>
                                                                        </ActionLink>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </TileBody>
                                                </Tile>
                                            </div>
                                        )}
                                        {!this.allowAddCropApplication && !this.allowAddPastureApplication && (
                                            <div className="Grid-cell u-mt-lg">
                                                <Tile title="Applications" tertiary>
                                                    <TileBody>
                                                        <div className="Table u-mt-md">
                                                            <div className="Tile-body">
                                                                <div className="Tile-body-message">
                                                                    <div>
                                                                        <p className="h4 u-mt-md">No fruit or pasture blocks have been created</p>
                                                                        <Link className="IconLink--arrow-plus Button Button--sm u-mt-md" to={`/app/farm/${this.props.farm.id}/analysis/${this.props.budget.id}`}>
                                                                            Create Block
                                                                        </Link>
                                                                    </div>
                                                                    <div className="u-pt-lg">
                                                                        <p className="h4 u-mt-md">No crop blocks have been created</p>
                                                                        <Link className="IconLink--arrow-plus Button Button--sm u-mt-md" to={`/app/farm/${this.props.farm.id}/analysis/${this.props.budget.id}`}>
                                                                            Create Block
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </TileBody>
                                                </Tile>
                                            </div>
                                        )}
                                    </TileBody>
                                    <TileFooter>
                                        <div className="ButtonBar ButtonBar--fixed">
                                            <div className="ButtonBar-left">
                                                <Link to={_referrer} className="Button Button--secondary">
                                                    Cancel
                                                </Link>
                                                {!this.props.isNew && values.fertiliser.isLastPreviousLime && (
                                                    <button type="button" onClick={() => this.props.deleteFertiliserPrompt()} className="Button Button--secondary" id="fertiliser-system-delete">
                                                        Delete
                                                    </button>
                                                )}
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button type="submit" className="Button Button--primary" id="fertiliser-system-submit" onClick={() => preSubmit()}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </TileFooter>
                                </Tile>
                            </form>
                        );
                    }}
                />
            </React.Fragment>
        );
    }
}

export default compose(
    withAppContext,
    withActions({ modal }),
    withState((state) => {
        return {
            isModalOpen: state.app.modal && state.app.modal.modalType && state.app.modal.modalType.length > 0,
        };
    })
)(Details);
